import { GameReponseType } from "magic-shared-types";
import { api } from "../api";
import { BASE_SERVER_PATH } from "../../constant";

export const myServerApis = api.injectEndpoints({
  endpoints: (builder) => ({
    getGames: builder.query<{ games: GameReponseType[] }, void>({
      query: () => ({
        url: `${BASE_SERVER_PATH}/api/games`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
        },
      }),
    }),
  }),
});

export const { useGetGamesQuery } = myServerApis;
